import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAppInsights } from '../../plugins/telemetry/telemetryService';

/**
 * Component to track route changes with Application Insights
 * Should be placed inside Router but outside Routes
 */
const AppInsightsRouter: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const location = useLocation();
    const appInsights = getAppInsights();

    useEffect(() => {
        // Skip tracking in local development
        const isLocalDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        if (isLocalDevelopment) {
            return;
        }

        if (appInsights) {
            appInsights.trackPageView({
                name: location.pathname,
                uri: `${window.location.origin}${location.pathname}${location.search}`,
            });
        }
    }, [location, appInsights]);

    return <>{children}</>;
};

export default AppInsightsRouter;